interface Props {
  children?: React.ReactNode;
  value: string;
  tabKey: string;
}

export default function TabPanel(props: Props) {
  const { children, value, tabKey, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== tabKey}
      {...other}
    >
      {value === tabKey && children}
    </div>
  );
}
